module.exports = __webpack_public_path__ + "img/yuanwei2.2a6480be.png";